import TableCustomized from "../../../common/components/TableCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";
import { formattedDateTimeFromDB } from "../../../common/utils/FunctionsUtils";

function ListHistorique(props) {
  const columns = [
    {
      field: "numEchange",
      headerName: "N° Echange",
      flex: 1,
      minWidth: 130,
      maxWidth: 130,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "fonctionDemande",
      headerName: "Fonction de la demande",
      flex: 1,
      minWidth: 250,
      maxWidth: 250,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "nomMessage",
      headerName: "Nom message",
      flex: 1,
      minWidth: 130,
      maxWidth: 130,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "etat",
      headerName: "Etat",
      flex: 1,
      minWidth: 220,
      maxWidth: 250,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 160,
      maxWidth: 200,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "nomUtilisateur",
      headerName: "Nom utilisateur",
      flex: 1,
      minWidth: 170,
      maxWidth: 200,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "recepteurMessage",
      headerName: "Récepteur du message",
      flex: 1,
      minWidth: 200,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "observation",
      headerName: "Observation",
      flex: 1,
      minWidth: 200,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "besoinReponse",
      headerName: "Besoin réponse",
      flex: 1,
      minWidth: 200,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
  ];
  const rows = [];

  props?.historique?.content?.messages?.map((row, index) => {
    rows.push({
      id: row?.id,
      numEchange: row?.numIntercambio,
      fonctionDemande:
        row?.typeMessage?.description + " " + row?.typeMessage?.code || "-",
      nomMessage: row?.nombreMensaje,
      etat: row?.etat?.description,
      recepteurMessage: row?.typeRecepteur?.description,
      date: formattedDateTimeFromDB(row?.fechaMsg),
      nomUtilisateur: row?.nombreUsuario,
      observation: row?.observation,
      besoinReponse: row?.sinRespuesta ? "Oui" : "Non",
    });
  });

  return (
    <PaperCustomized title="Suivi du titre d'importation" forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={props?.historique?.totalElements}
        pageSizeOptions={[10, 25, 50, 100]}
        customInitialState={rows.length}
        loading={props?.loading}
        paginationMode="client"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListHistorique;
